export const cilMicrophone = ["24 24","<path d='M12 15.375c2.484-0.003 4.497-2.016 4.5-4.5v-5.625c0-2.485-2.015-4.5-4.5-4.5s-4.5 2.015-4.5 4.5v0 5.625c0.003 2.484 2.016 4.497 4.5 4.5h0zM9 5.25c0-1.657 1.343-3 3-3s3 1.343 3 3v0 5.625c0 1.657-1.343 3-3 3s-3-1.343-3-3v0z'></path><path d='M18.75 8.25v2.625c0 3.722-3.028 6.75-6.75 6.75s-6.75-3.028-6.75-6.75v-2.625h-1.5v2.625c0 4.296 3.301 7.835 7.5 8.216v4.159h1.5v-4.159c4.199-0.381 7.5-3.92 7.5-8.216v-2.625z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-microphone.js
// module id = null
// module chunks = 